/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SuspendedInputs */

const en__field_suspended = /** @type {(inputs: _Field_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspended`)
};

const de__field_suspended = /** @type {(inputs: _Field_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspendiert`)
};

/**
* | output |
* | --- |
* | "Suspended" |
*
* @param {_Field_SuspendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_suspended = /** @type {((inputs?: _Field_SuspendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SuspendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_suspended(inputs)
	return de__field_suspended(inputs)
});